import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation, Trans } from "next-i18next";

const CONTACT_EMAIL = "support@reefli.com";

export default function ImpressumPage() {
  const { t } = useTranslation("imprint");

  return (
    <div className="font-[futura] text-[#262104] min-h-screen flex flex-col">
      <Navbar />
      <main className="max-w-6xl w-full mx-auto mt-20 py-12 flex-grow px-4 bg-white rounded-2xl">
        <h1 className="text-xl font-bold mb-8">{t("title")}</h1>

        <Section titleKey="s1_title">
          <Trans i18nKey="s1_body" ns="imprint" components={{ br: <br /> }} />
        </Section>

        <Section titleKey="s2_title">
          <Trans i18nKey="s2_body" ns="imprint" components={{ br: <br /> }} />
        </Section>

        <Section titleKey="s3_title">
          <Trans
            i18nKey="s3_body"
            ns="imprint"
            values={{ email: CONTACT_EMAIL }}
          />
        </Section>

        <Section titleKey="s4_title">
          <Trans i18nKey="s4_body" ns="imprint" components={{ br: <br /> }} />
        </Section>

        <Section titleKey="s5_title">
          <Trans i18nKey="s5_body" ns="imprint" />
        </Section>
      </main>
      <Footer />
    </div>
  );
}

function Section({ titleKey, children }) {
  const { t } = useTranslation("imprint");
  return (
    <section className="mb-8">
      <h2 className="text-md font-semibold mb-2">{t(titleKey)}</h2>
      <p className="leading-relaxed">{children}</p>
    </section>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        "navbar",
        "footer",
        "imprint",
      ])),
    },
  };
}
